import React, { useState } from "react"
import { Button, Modal } from "react-bootstrap"

const SWUpdateDialog: React.FC<{ registration: ServiceWorkerRegistration }> = (
  props
) => {
  const [show, setShow] = useState(!!props.registration.waiting)

  const updateHandler = () => {
    props.registration.waiting?.postMessage({ type: "SKIP_WAITING" })
    setShow(false)
    window.location.reload()
  }

  return show ? (
    <Modal
      show={true}
      backdrop="static"
      keyboard={false}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Body className="text-center">
        <p>最新のアプリが提供されています。ボタンを押して更新してください</p>
        <Button variant="link" onClick={updateHandler}>
          更新する
        </Button>
      </Modal.Body>
    </Modal>
  ) : (
    <></>
  )
}

export default SWUpdateDialog
